import Accordion from 'components/accordion';

function Faq($element, options = {}) {
    this.$element = $element;
    this.options = options;

    this.$items = this.$element.querySelector('.js-faq-items');
    this.items = [...this.$element.querySelectorAll('.js-faq-accordion')].map($item => new Accordion($item));
}

export default Faq;
